import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDotlegalChatIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.2778 0.5H4.72222C2.38944 0.5 0.5 2.40188 0.5 4.75V9C0.5 11.3481 2.38944 13.25 4.72222 13.25H5.77778V17.5L10.5278 13.25H15.2778C17.6106 13.25 19.5 11.3481 19.5 9V4.75C19.5 2.40188 17.6106 0.5 15.2778 0.5Z",
		fill: "#DAD9EF",
		stroke: "#7284FA",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgDotlegalChatIcon;
